/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument */
import type { Container } from 'pixi.js';
import { soundManager } from '../../../app/SoundManager';
import type { AnyModel } from './types/models';

export function setInteractivitySounds(view: Container, model: AnyModel<any>): void {
  if (typeof model?.data?.tapSound === 'string') {
    view.on('pointertap', () => {
      soundManager.play(model.data.tapSound);
    });
  }
}
